module.exports = __webpack_public_path__ + "media/images/photos/20-7369df5cb581c7556ffec9e4f30fcf5a.jpg";